var _style, _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgWeather = function SvgWeather(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svgWeather",
    x: "0px",
    y: "0px",
    width: "21px",
    height: "21px",
    viewBox: "0 0 21 21",
    style: {
      enableBackground: "new 0 0 21 21"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.svgWeather{fill:#B5B5B5;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path_weather",
    className: "svgWeather svgBase svgHover svgSelect",
    d: "M17.9,9.2c0-0.2,0-0.4,0-0.6c0-2.8-2.2-5.2-5.1-5.2c-1.8,0-3.5,0.9-4.5,2.5 C7.8,5.5,7.2,5.3,6.5,5.3C4.5,5.4,3,6.9,3,8.9C3,9.1,3,9.3,3,9.5c-1.7,0.6-2.8,2.2-2.8,4c0,2.2,1.8,4.1,4,4.1c0.1,0,0.1,0,0.2,0h12 c2.3,0,4.2-1.9,4.2-4.3C20.7,11.5,19.6,9.9,17.9,9.2z M16.5,16.5h-12c-1.7,0.1-3.1-1.2-3.2-2.9c0,0,0-0.1,0-0.1c0-1.5,1-2.8,2.5-3.2 c0.1,0,0.3-0.1,0.3-0.2c0.1-0.1,0.1-0.3,0-0.4C3.7,8.3,4.4,6.9,5.7,6.5c0.2-0.1,0.5-0.1,0.8-0.1c0.7,0,1.3,0.3,1.8,0.7 c0.2,0.2,0.5,0.2,0.7,0C9,7,9,7,9,6.9c0.9-2.1,3.4-3,5.4-2.1C16,5.5,16.9,7,16.9,8.6c0,0.3,0,0.6-0.1,0.9c0,0.3,0.1,0.5,0.4,0.6 c1.7,0.4,2.8,2.2,2.4,3.9C19.3,15.5,18,16.5,16.5,16.5L16.5,16.5z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWeather, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/weather.7c947403.svg";
export { ForwardRef as ReactComponent };